/**
 * THE SHORTEST STAY THAT IS MID-TERM — A COMPANY SETTING, NOT A NUMBER IN THE CODE (2026-10-07).
 *
 * Thirty nights is where this product begins: below it a stay is priced, taxed and cleaned as a short
 * stay and belongs to the other half of the company (Seattle's short-term rental rules, SMC 6.600, and
 * Washington's lodging tax, WAC 458-20-166, both draw the line at 30). It used to be written in four
 * places as `30`. It is now one value, kept in `mtr.company_settings` under `mid_term` and changed by an
 * admin in Setup → Stay rules. Thirty is only what it is until somebody saves another number.
 *
 * ONE LIVE VALUE. Every module that asks reads `MID_TERM_MINIMUM_NIGHTS` through an ES-module live
 * binding, so a default parameter written `minNights = MID_TERM_MINIMUM_NIGHTS` sees the company's
 * number at the moment it is called. Whoever reads `company_settings` — the staff app's load, the
 * listing server's read, the renter's page from the server's answer — calls `setMidTermMinimumNights`.
 */
export const MID_TERM_DEFAULT_NIGHTS = 30
/** The bounds a saved value must sit inside to be believed: a night, and a year. */
export const MID_TERM_LOWEST = 1
export const MID_TERM_HIGHEST = 365

export let MID_TERM_MINIMUM_NIGHTS = MID_TERM_DEFAULT_NIGHTS

/** A whole number of nights inside the bounds, or null. */
export function midTermNightsOrNull(n) {
  const v = typeof n === 'string' && n.trim() !== '' ? Number(n) : n
  return Number.isInteger(v) && v >= MID_TERM_LOWEST && v <= MID_TERM_HIGHEST ? v : null
}

/**
 * Make `n` the company's minimum everywhere in this running program. Anything unusable puts the
 * default back, so a bad row can never leave a stale number behind. Returns the value now in force.
 */
export function setMidTermMinimumNights(n) {
  MID_TERM_MINIMUM_NIGHTS = midTermNightsOrNull(n) ?? MID_TERM_DEFAULT_NIGHTS
  return MID_TERM_MINIMUM_NIGHTS
}
